let lockCount = 0;

export function resetLockCount() {
  lockCount = 0;
}

export function useOverlayScrollHelper() {
  const preventBgFromScrolling = () => {
    lockCount++;
    document.querySelector('body').style.overflow = 'hidden';
  };

  const allowBgToScroll = () => {
    lockCount = Math.max(0, lockCount - 1);
    if (lockCount === 0) {
      document.querySelector('body').style.overflow = 'auto';
    }
  };

  return {
    preventBgFromScrolling,
    allowBgToScroll,
  };
}
